/**
 * Butterbrotbande — Leseseiten für Blogartikel
 *
 * Zwei Bausteine, übernommen aus js/site.js der lokalen Birkly-Instanz:
 *   1. Fortschrittsbalken oben
 *   2. Inhaltsverzeichnis aus den <h2> des Artikels
 *
 * Läuft nur auf Artikelseiten. Auf Listen-, Produkt- und Kassenseiten passiert
 * nichts — dort stört ein Lesefortschritt nur.
 *
 * Bewusst OHNE requestAnimationFrame-Ticking: Chrome drosselt rAF in
 * Hintergrund-Tabs, der Callback bleibt aus, das ticking-Flag steht dauerhaft
 * auf true und der Balken friert für immer ein. Der Wert wird deshalb direkt
 * im passiven Scroll-Handler gerechnet — das ist billig genug.
 */
(function () {
  'use strict';

  function istArtikel() {
    var main = document.querySelector('main[data-template]');
    return !!main && main.dataset.template.indexOf('article') === 0;
  }

  /** Umlautfester Slug für die Sprungmarken. */
  function idAus(text, nummer) {
    var s = String(text)
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return s ? 'abschnitt-' + s : 'abschnitt-' + nummer;
  }

  function fortschritt() {
    var leiste = document.createElement('div');
    leiste.className = 'bbb-leseleiste';
    var fuellung = document.createElement('span');
    leiste.appendChild(fuellung);
    document.body.appendChild(leiste);

    function rechne() {
      var doc = document.documentElement;
      var hoehe = doc.scrollHeight - window.innerHeight;
      var anteil = hoehe > 0 ? (window.scrollY / hoehe) * 100 : 0;
      fuellung.style.width = Math.min(100, Math.max(0, anteil)) + '%';
    }

    window.addEventListener('scroll', rechne, { passive: true });
    window.addEventListener('resize', rechne, { passive: true });
    rechne();
  }

  function verzeichnis() {
    var text = document.querySelector('main .rte');
    if (!text) return;

    var ueberschriften = [].slice.call(text.querySelectorAll('h2'));
    if (ueberschriften.length < 2) return;

    var liste = document.createElement('ul');
    liste.className = 'bbb-toc';

    ueberschriften.forEach(function (h, i) {
      if (!h.id) h.id = idAus(h.textContent, i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      liste.appendChild(li);
    });

    text.parentNode.insertBefore(liste, text);

    if (!('IntersectionObserver' in window)) return;
    var beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          liste.querySelectorAll('a').forEach(function (a) {
            a.setAttribute('aria-current', a.getAttribute('href') === '#' + e.target.id ? 'true' : 'false');
          });
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    ueberschriften.forEach(function (h) {
      beobachter.observe(h);
    });
  }

  function start() {
    if (!istArtikel()) return;
    fortschritt();
    verzeichnis();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
